import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';



const Login = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);


    const [inputData, setInputData] = useState({
        email: localStorage.getItem('@email'),
        otp: "",
    });
    useEffect(() => {
        document.title = 'Roam Pays: Register';
      }, []);
    const handleRegisterOtp = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(null);

        const { email, otp } = inputData;
        if (!email || !otp) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);
            await axios.post(process.env.REACT_APP_API_URL + "/register-email-otp", {
                email: email,
                otp: otp,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                        
                        localStorage.setItem("@email", email)
                         localStorage.setItem('@roampays-user', JSON.stringify(response.data.user))
                        navigate("/calculate");

                        

                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Error", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };

    const handleSendOtpAgain = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(null);

        const { email } = inputData;
        if (!email ) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);
            await axios.post(process.env.REACT_APP_API_URL + "/register-email", {
                email: email,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                       
                            localStorage.setItem("@email", email)
                            setErrorResponse("Authentication Code sent again.");

                        

                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Error", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };

    return (


        <div class="form-container">

{errorResponse &&
                <div className="color-white fs-14" role="alert">
                    {errorResponse}
                </div>
            }

            <h3 className="form-title color-white">Enter the Code</h3>

            <label className="fs-16 color-white">We've sent it to {inputData.email}</label>
           
                <div className="input-text" >
                <label className="color-light fs-12">Verification Code</label>

                <input type="text" className="color-light fs-14" id="otp"
                    name="otp" value={inputData.otp}
                    onChange={(e) => setInputData({ ...inputData, otp: e.target.value })}
                />

                {inputError && !inputData.otp && (
                    <span className="color-white fs-14">This field is required</span>
                )}
           </div>

            <button type="button" onClick={handleRegisterOtp} className="button-purple fs-14 color-white" disabled={isBtn}>
                {isBtn ? <Loading size={'20px'} /> : 'Continue'}
            </button>
         

            <div >
            <Link className="content-lg fs-14 color-white" to="/register"> Go Back</Link>
            </div>

            <div className="content fs-12 color-white" >
                Didn't get the code? <a href="#" onClick={handleSendOtpAgain}>Send Again</a>
            </div>

           
         

        </div>


    );
};

export default Login;